<div class="multiSelect">
    @if (form.controls['searchInput']!.enabled) {
        <div
            class="multiSelectWrapper"
            [class.disabled]="false"
            [formGroup]="form"
            [ngClass]="{ open: (showDropdown | async) && filteredAvailableOptionsList.length, top: dropdownTopPositioning }"
        >
            <input
                type="text"
                autocomplete="off"
                formControlName="searchInput"
                #multiSelectInput
                (blur)="closeOptionsList(); onBlur()"
                (focus)="openOptionsList()"
                (clickOutside)="closeOptionsList()"
                (mousedown)="openOptionsList()"
                (keydown.space)="onSpaceKey($event)"
                (keydown.enter)="onEnterKey($event)"
                (keydown.arrowDown)="moveDown()"
                (keydown.arrowUp)="moveUp()"
            />
            @if (form.controls['searchInput']!.value) {
                <button
                    type="button"
                    class="button transparent iconSmall confirm"
                    title="{{ 'generalKeywords.confirm' | translate }}"
                    (click)="addCustomOption()"
                >
                    <i class="fas fa-check"></i>
                </button>
            }
            @if (showDropdown | async) {
                <ul class="menuList card dropdownMenu" #dropdownMenu>
                    @if ((showDropdown | async) && filteredAvailableOptionsList.length) {
                        @for (option of filteredAvailableOptionsList; track option; let i = $index) {
                            <li
                                class="noFixedWidth menuItemAuto"
                                #menuItemAuto
                                (mousemove)="mouseMove(i)"
                                (mousedown)="selectOption(filteredAvailableOptionsList[i], true, $event)"
                                [ngClass]="{ selected: i === selectedIndex }"
                                [innerHTML]="filteredAvailableOptionsList[i].label! | translate | highlight: multiSelectInput.value"
                            >
                                {{ option.label | translate }}
                            </li>
                        }
                    }
                </ul>
            }
        </div>
    }
    <div class="pillContainer">
        @if (selectedOptions && selectedOptions.length > 3) {
            <div>
                <div class="pill">
                    <span>{{ selectedOptions[0].label | translate }}</span>

                    @if (!isDisabled) {
                        <button class="transparent icon fal fa-xmark" type="button" (click)="deselectOption(selectedOptions[0])"></button>
                    }
                </div>
                <div class="pill">
                    <span>{{ selectedOptions[1].label | translate }}</span>

                    @if (!isDisabled) {
                        <button class="transparent icon fal fa-xmark" type="button" (click)="deselectOption(selectedOptions[1])"></button>
                    }
                </div>
                <div class="link" (click)="openSelectedOptionsModal()">
                    @if (!isDisabled) {
                        <button class="transparent" type="button">
                            {{ 'multiselect.showAll' | translate: { total: selectedOptions.length } }}
                        </button>
                    }
                </div>
            </div>
        } @else {
            @for (option of selectedOptions; track option.id || option.label) {
                <div class="pill">
                    <span>{{ option.label | translate }}</span>
                    @if (!isDisabled) {
                        <button class="transparent icon fal fa-xmark" type="button" (click)="deselectOption(option)"></button>
                    }
                </div>
            }
        }
    </div>
    @if (selectedOptions && selectedOptions.length > 1) {
        <button class="button danger" type="button" (click)="deselectAll()">
            {{ 'multiselect.removeAll' | translate }}
        </button>
    }
</div>
